import type { CustomAttributeDefinition } from "@jti/fe-common";

export const sortCustomAttributes = (customAttributes: CustomAttributeDefinition[]): CustomAttributeDefinition[] => {
  const withEmptyDisplayAfter = customAttributes.filter(({ display_after }) => !display_after);
  if (withEmptyDisplayAfter.length === 0) {
    console.warn(
      "Wrong configuration - all attributes have display_after set. No starting point found (circular dependency or invalid references). Using default order."
    );
    return customAttributes;
  }
  const withDisplayAfter = customAttributes.filter(({ display_after }) => display_after);
  const results = [...withEmptyDisplayAfter];
  let iteration = 0;
  while (iteration < withDisplayAfter.length) {
    const index = results.findIndex(({ code }) => code === withDisplayAfter[iteration].display_after);
    if (index >= 0) {
      results.splice(index + 1, 0, withDisplayAfter[iteration]);
      withDisplayAfter.splice(iteration, 1);
      iteration = 0;
    } else {
      iteration++;
    }
  }
  if (withDisplayAfter.length) {
    console.warn(
      "Wrong configuration - circular dependency in custom attributes or typo in display_after (using default order)"
    );
    return customAttributes;
  }
  return results;
};
